import React from "react";
import { Container, Grid } from "@mui/material";
import MyAccomplishmentsCard from "./Accomplishment/MyAccomplishmentsCard";
import MyEnrolmentsCard from "./Enrolment/MyEnrolmentsCard";
import MyEventsCard from "./Event/MyEventsCard";
import LibraryCard from "./Library/LibraryCard";
import WelcomeCard from "../CMS/WelcomeCard";

import BreadcrumbBuilder from "./BreadcrumbBuilder";

function Dashboard() {
    return (
        <Container className="content">
            <Grid container spacing={3} className="card-grid">
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                <Grid item xs={12}>
                    <WelcomeCard appCode={"C-TMS"} />
                </Grid>
                <Grid
                    item
                    sm={12}
                    md={6}
                    lg={6}
                    xl={4}
                    className="card-grid-item"
                >
                    <MyEnrolmentsCard />
                </Grid>
                <Grid
                    item
                    sm={12}
                    md={6}
                    lg={6}
                    xl={4}
                    className="card-grid-item"
                >
                    <LibraryCard />
                </Grid>
                <Grid
                    item
                    sm={12}
                    md={6}
                    lg={6}
                    xl={4}
                    className="card-grid-item"
                >
                    <MyEventsCard />
                </Grid>
                <Grid
                    item
                    sm={12}
                    md={6}
                    lg={6}
                    xl={4}
                    className="card-grid-item"
                >
                    <MyAccomplishmentsCard />
                </Grid>
            </Grid>
        </Container>
    );
}

export default Dashboard;
